import { render, staticRenderFns } from "./LinksRules.vue?vue&type=template&id=93574d6a&scoped=true&"
import script from "./LinksRules.vue?vue&type=script&lang=js&"
export * from "./LinksRules.vue?vue&type=script&lang=js&"
import style0 from "./LinksRules.vue?vue&type=style&index=0&id=93574d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93574d6a",
  null
  
)

export default component.exports